type Size =
  | "icon" /* 15x15 */
  | "button" /* 20x20 */
  | "extra_small" /* 30x30 */
  | "small" /* 40x40 */
  | "medium" /* 55x55 */
  | "large" /* 175x175 */;

export default function getCountryFlagUrl(country = "", size: Size = "large") {
  const template = process.env.VUE_APP_CDN_FLAGS_URL;
  const flagCode = country.toLowerCase();

  return template.replace("{{size}}", size).replace("{{country}}", flagCode);
}
